
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/fixed/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-fixed-demo-base","pages-pages-reference-fixed-demo-plural"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/fixed/index.md?type=demo')
};